module.exports = __webpack_public_path__ + "img/hdc_07.1294308b.png";